import { useRef } from 'react';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import { tokens } from 'src/locales/tokens';
import BackNavigation from 'src/components/ui/headers/title-back';
import { DetailView } from './detail-view';
import PageSection from 'src/layouts/page-section';

const Page = ({ onNavigate, item }) => {
  const { t } = useTranslation();
  const rootRef = useRef(null);
  
  return (
    <PageSection title="Repair" rootRef={rootRef}>
      <Stack spacing={1}>
        <BackNavigation
          onBackClick={onNavigate}
          label={t(tokens.nav.repair)}
        />
        <Stack>
          <DetailView item={item} />
        </Stack>
      </Stack>
    </PageSection>
  );
};

export default Page;